export const INTERVIEW_ALLOW_USER = "INTERVIEW_ALLOW_USER";
export const INTERVIEW_ASK_TO_JOIN = "INTERVIEW_ASK_TO_JOIN";
export const INTERVIEW_ADD_QUESTION = "INTERVIEW_ADD_QUESTION";
export const INTERVIEW_DENY_USER = "INTERVIEW_DENY_USER";
export const INTERVIEW_END_FOR_ME = "INTERVIEW_END_FOR_ME";
export const INTERVIEW_LEAVE_FOR_ALL = "INTERVIEW_LEAVE_FOR_ALL";
export const INTERVIEW_REMOVE_QUESTION = "INTERVIEW_REMOVE_QUESTION";
export const INTERVIEW_SCREEN_SHARE_STOPPED = "INTERVIEW_SCREEN_SHARE_STOPPED";
export const INTERVIEW_SOLUTION_CREATED = "INTERVIEW_SOLUTION_CREATED";
export const INTERVIEW_UPDATE_QUESTION = "INTERVIEW_UPDATE_QUESTION";
export const INTERVIEW_USER_JOINED = "INTERVIEW_USER_JOINED";
export const INTERVIEW_USER_LEAVE = "INTERVIEW_USER_LEAVE";
export const INTERVIEW_PRE_USER_JOINED = "INTERVIEW_PRE_USER_JOINED";
export const CODE_ASYNC = "code-async";
export const CODE_EVALUATED = "code-evaluated";
export const COLLAB_ABORT_RUN_CODE = "COLLAB_ABORT_RUN_CODE";
export const COLLAB_USER_MOVED_OUT = "COLLAB_USER_MOVED_OUT";
export const COLLAB_USER_COME_IN = "COLLAB_USER_COME_IN";
export const COLLAB_INITIATE_RUN_CODE = "COLLAB_INITIATE_RUN_CODE";
export const COLLAB_RUN_CODE_SUCCESS = "COLLAB_RUN_CODE_SUCCESS";
export const EDITOR_BATCH_EVENTS = "EDITOR_BATCH_EVENTS";
export const EDITOR_CODE_SYNC = "EDITOR_CODE_SYNC";
export const EDITOR_CURSOR_POSITION_CHANGE = "EDITOR_CURSOR_POSITION_CHANGE";
export const EDITOR_DELETE = "EDITOR_DELETE";
export const EDITOR_INSERT = "EDITOR_INSERT";
export const EDITOR_LANGUAGE_CHANGED = "EDITOR_LANGUAGE_CHANGED";
export const EDITOR_RELOAD_STUB = "EDITOR_RELOAD_STUB";
export const EDITOR_REPLACE = "EDITOR_REPLACE";
export const EDITOR_SELECTION_CHANGE = "EDITOR_SELECTION_CHANGE";
export const WHITEBOARD_UPDATE_DRAWING = "WHITEBOARD_UPDATE_DRAWING";
export const WHITEBOARD_UPDATE_POINTER = "WHITEBOARD_UPDATE_POINTER";
export const WHITEBOARD_DRAWING_SYNC = "WHITEBOARD_DRAWING_SYNC";
export const SOCKET_CONNECT = "connect";
export const SOCKET_CONNECT_ERROR = "connect_error";
export const SOCKET_ERROR = "error";
export const SOCKET_DISCONNECT = "disconnect";

export const SUBJECTIVE_INSERT = "SUBJECTIVE_INSERT";
export const SUBJECTIVE_DELETE = "SUBJECTIVE_DELETE";
export const SUBJECTIVE_FORMAT = "SUBJECTIVE_FORMAT";
export const SUBJECTIVE_BATCH_EVENTS = "SUBJECTIVE_BATCH_EVENTS";
export const SUBJECTIVE_CURSOR_CHANGE = "SUBJECTIVE_CURSOR_CHANGE";
export const SUBJECTIVE_SELECTION_CHANGE = "SUBJECTIVE_SELECTION_CHANGE";
export const SUBJECTIVE_CONTENT_SYNC = "SUBJECTIVE_CONTENT_SYNC";
export const SUBJECTIVE_ATTACHMENTS_CHANGE = "SUBJECTIVE_ATTACHMENTS_CHANGE";
